export default __webpack_public_path__ + "static/media/back.ad84bf3f.jpg";